module.exports = __webpack_public_path__ + "static/media/iframe-widget.d157ce64.svg";